// Site-wide strip above the brand-refresh nav, styled to match the bar on www.viewrail.com. The brand chrome
// replaces the Studio header (and the home + landing pages carry no Studio content), so the message lives here.
// Set ANNOUNCEMENT to null to hide the bar.
export const ANNOUNCEMENT: { text: string; emphasis?: string } | null = {
  text: 'All Viewrail Cable Railing Systems upgraded to thicker, more durable cable:',
  emphasis: '5/32"',
};

const AnnouncementBar = () => {
  if (!ANNOUNCEMENT) return null;

  return (
    <div className="bg-black px-16 py-6 text-center text-12 font-medium uppercase leading-normal tracking-[0.02em] text-white md:text-14">
      {ANNOUNCEMENT.text}
      {ANNOUNCEMENT.emphasis && (
        <>
          {' '}
          <span className="whitespace-nowrap font-semibold">{ANNOUNCEMENT.emphasis}</span>
        </>
      )}
    </div>
  );
};

export default AnnouncementBar;
